import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

import config from "config.json";
import "assets/js/smtp";
import { FormBuilder, FormGroup } from "@angular/forms";

declare let Email: any;

@Component({
  selector: "app-presentation-analysis-report",
  templateUrl: "./presentation-analysis-report.component.html",
  styleUrls: ["./presentation-analysis-report.component.css"],
})
export class PresentationAnalysisReportComponent implements OnInit {
  public clienInfoForm: FormGroup;
  formIsSending: boolean = false;
  displayLink: boolean = false;

  constructor(public router: Router, private fb: FormBuilder) {}

  ngOnInit(): void {
    document.documentElement.style.setProperty(
      "--color",
      !(this.router.url === "/home" || this.router.url === "/")
        ? "black"
        : "white"
    );
    this.clienInfoForm = this.fb.group({
      email: [null],
      name: [null],
      phoneNumber: [null],
      organisation: [null],
    });
  }

  sendDetails(evt): void {
    this.formIsSending = true;
    Email.send({
      Host: config.hostname,
      Username: config.username,
      Password: config.password,
      To: config.recieveremail,
      From: config.adminemail,
      Subject: "SMX Corporate Presentation Registration",
      Body:
        "<b>Name:</b> " +
        this.clienInfoForm.controls.name.value +
        "<br />" +
        "<b>Email: </b>" +
        this.clienInfoForm.controls.email.value +
        "<br />" +
        "<b>Phone Number: </b>" +
        this.clienInfoForm.controls.phoneNumber.value +
        "<br />" +
        "<b>Organisation: </b>" +
        this.clienInfoForm.controls.organisation.value,
    });

    setTimeout(() => {
      this.displayLink = true;
      this.formIsSending = false;
      this.clienInfoForm.reset();
    }, 3000);
  }
}
